module.exports = __webpack_public_path__ + "img/jnv.11ddae98.jpg";